import { subtract } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";

const getMinValue = (...args) => {
  if (args.length === 0) {
    throw new Error("At least one number must be provided");
  }

  let smallest = Number(args[0]);

  for (let i = 1; i < args.length; i++) {
    if (Number(args[i]) < smallest || smallest === 0) {
      if (args[i] !== 0) {
        smallest = Number(args[i]);
      }
    }
  }
  return smallest;
};

const PortFinalNetWeight = ({ dispatch, net_weight, received_weight, returnBagQty, miller_bill_weight, unit, contract_type  }) => {
  console.log(contract_type)
  const finalVal = contract_type !== "FOR"
  ? Number(getMinValue(dispatch, net_weight,miller_bill_weight) - Number(returnBagQty || 0)).toFixed(3)
  : Number(getMinValue(dispatch, net_weight,received_weight, miller_bill_weight) - Number(returnBagQty || 0)).toFixed(3);
  return (
    <FormulaLayoutUI>
      <strong>Final Net Weight Formula:</strong>
      <br />
      <br />
      {contract_type !== "FOR"
      ? `= min(Miller Bill Weight, Dispatch Weight, Net Weight(Dispatch)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}` 
      : `= min(Miller Bill Weight, Dispatch Weight, Port Received Weight, Net Weight(Arrival)) ${returnBagQty > 0  ? `- Return Bag Qty` : ""}`}
      <br />
      {contract_type !== "FOR"
      ? `= min(${miller_bill_weight}, ${dispatch}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}`
      : ` = min(${miller_bill_weight}, ${dispatch}, ${received_weight}, ${net_weight}) ${returnBagQty > 0  ? `- ${returnBagQty}` : ""}
      `}
      <br />
      <strong> </strong> = {finalVal} {unit}
    </FormulaLayoutUI>
  );
};

export default PortFinalNetWeight;
